import { Record } from 'immutable';
import mapKeys from 'lodash/mapKeys';
import camelCase from 'lodash/camelCase';

// http://developer.parkwhiz.com/v4/#cancellable-status
export default class CancellableStatus extends Record({
  cancellableNow: null,
  code: null,
  message: null,
}) {
  constructor(props) {
    super(mapKeys(props, (v, k) => camelCase(k)));
  }
}

// cancellable_status.code values from API docs.
export const BOOKING_ALREADY_CANCELLED = 'booking_already_cancelled';
export const BOOKING_IS_MONTHLY = 'booking_is_monthly';
export const BOOKING_IS_NOT_CANCELLABLE = 'booking_is_not_cancellable';
export const CANCELLABLE_DURING_CANCELLATION_PERIOD = 'cancellable_during_cancellation_period';
export const CANCELLABLE_UNTIL_START_TIME = 'cancellable_until_start_time';
export const CANCELLATION_PERIOD_EXPIRED = 'cancellation_period_expired';
export const CANCELLING_IN_PROGRESS_BOOKING = 'cancelling_in_progress_booking';
export const CANCELLING_PAST_BOOKING = 'cancelling_past_booking';
export const CUSTOMER_IS_NON_REFUNDABLE = 'customer_is_non_refundable';
export const EVENT_PACKAGE_BOOKING_NOT_CANCELLABLE = 'event_package_booking_not_cancellable';
export const ON_DEMAND_BOOKING_NOT_CANCELLABLE = 'on_demand_booking_not_cancellable';
export const PARTNER_BOOKING_NOT_CANCELLABLE = 'partner_booking_not_cancellable';

// Codes related to cancellation derived from client state - not returned from the API.
export const NOT_AUTHORIZED = 'not_logged_in';
export const SURPASSED_START_TIME = 'surpassed_start_time';
// returned by userCannoteCancelCode() if the user is able to currently cancel
export const USER_CAN_CANCEL = 'user-can-cancel';
